import caseA from '/public/images/testemonials/t1.webp'
import caseB from '/public/images/testemonials/t2.webp'
import caseC from '/public/images/testemonials/t3.webp'
import caseD from '/public/images/testemonials/t4.webp'

export const TESTIMONIALS = {
  case1: { path: caseA, alt: 'Depoimento 1' },
  case2: { path: caseB, alt: 'Depoimento 2' },
  case3: { path: caseC, alt: 'Depoimento 3' },
  case4: { path: caseD, alt: 'Depoimento 4' }
}
